import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function ImageComponent () {
  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [errorType, setErrorType] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [values, setValues] = useState({});
  const [file, setFile] = useState();

  function handleChangeValues (event) {
    setValues({ ...values, [event.target.name]: event.target.value });
  }
  function showError () {
    setErrorType(true);
    setTimeout(() => setErrorType(false), 3000);
  }
  function handleChangeFile (event) {
    const file2 = event.target.files[0];
    if (file2.type === 'image/jpeg'
      || file2.type === 'image/png'
      || file2.type === 'image/svg+xml') {
      setFile(file2);
      setValues({ ...values, [event.target.name]: event.target.value });
    } else {
      showError();
      setFile();
      setValues({ ...values, [event.target.name]: '' });
    }
  }

  function handleSubmit (event) {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      const data = new FormData();
      data.set('thumbnail', file);
      data.set('route', values.route);

      api.put('/componentsimage', data)
        .then(() => {
          setValues({
            thumbnail: '',
            route: '',
          });
          setFile(null);
          setSuccess(true);
          const element = document.getElementById('msgSuccess');
          element.innerHTML = 'Componente cadastrado com sucesso';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  }
  return (
    <div className="content-register-component">
      {errorType ? (
        <Error>
          <p>Formato inválido para o arquivo. Só são permitidos arquivos PNG, JPG/JPEG e SVG.'</p>
        </Error>
      ) : null}
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <Card>
        <Card.Header>
          <h5>Atualizar thumbnail componente</h5>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>

            <Form.Group controlId="formRoute">
              <Form.Label>Rota</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.route}
                name="route"
                required
                type="text"
                placeholder="Entre com a rota"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com a rota
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formRoute">

              <Form.File
                id="thumbnail"
                label="Nova thumbnail"
                onChange={handleChangeFile}
                value={values.thumbnail}
                name="thumbnail"
                required
              />

            </Form.Group>

            <Button block type="submit" variant="success">Atualizar</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
